import { types as actions } from '../actions';

const defaultState = {
  list: [],
  currentTrigger: {}
};

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case actions.SET_TRIGGERS:
      return {
        ...state,
        list: action.triggers
      };
    case actions.ADDED_TRIGGER:
      let found = state.list.find(trigger => trigger.id === action.trigger.id);
      return {
        ...state,
        list: found ? state.list : [...state.list, action.trigger]
      };
    case actions.ADDED_ACTION:
    case actions.EDITED_ACTION:
      return {
        ...state,
        list: state.list.map(trigger => {
          if (trigger.id === action.action.trigger.id) {
            return {
              ...trigger,
              action: action.action
            };
          }
          return trigger;
        })
      };
    case actions.REMOVE_ACTION:
      return {
        ...state,
        list: state.list.map(trigger => {
          if (trigger.id === action.action.trigger.id) {
            return {
              ...trigger,
              action: null
            };
          }
          return trigger;
        })
      };
    case actions.SET_CURRENT_TRIGGER:
      return {
        ...state,
        currentTrigger: action.trigger
      };
    case actions.EDITED_TRIGGER:
      return {
        ...state,
        list: state.list.map(
          trigger =>
            trigger.id === action.trigger.id ? action.trigger : trigger
        )
      };
    case actions.REMOVE_TRIGGER:
      return {
        ...state,
        list: state.list.filter(trigger => trigger.id !== action.trigger.id)
      };
    case actions.LOGGED_OUT:
      return defaultState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/triggers/index.js